import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x",
  "use": "icon-x-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-x\">\n<rect x=\"-2.19141\" y=\"-1.03699\" width=\"18.3846\" height=\"15.5926\" fill=\"white\" stroke=\"#979797\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol